import { ScrollView } from "@-/com.npmjs.react-native";
import { SectionAccordionTab } from "@-/dev.improve.haniverse.components.ui.section-accordion";
import { useCallback, useRef, type ComponentProps } from "react";
import { DeckSectionScrollContext } from "#deck-section-scroll-context";

/** Owns only Deck's scroll ref; other accordion consumers keep their existing ref/lifecycle. */
export function DeckSectionAccordionTab(
  props: Omit<ComponentProps<typeof SectionAccordionTab>, "scrollView">,
) {
  const scrollRef = useRef<ScrollView>(null);
  const correctOffset = useCallback((y: number) => {
    scrollRef.current?.scrollTo({ animated: false, y });
  }, []);
  return (
    <DeckSectionScrollContext value={correctOffset}>
      <SectionAccordionTab {...props} scrollView={<ScrollView ref={scrollRef} />} />
    </DeckSectionScrollContext>
  );
}
